export const DOCUMENT_INTEGRATION = {
  DOCU_SIGN: 'docusign',
  ADOBE_SIGN: 'adobesign',
};

export default {
  DOCUMENT_INTEGRATION,
};
